import { useEffect, useState } from 'react';

import EventService from 'services/EventService';
import { EventMarketingInterface } from 'shared/interfaces/marketing/event-marketing.interface';

export const useEventMarketing = (eventId?: string | number) => {
	const [marketing, setMarketing] = useState<EventMarketingInterface[] | null>(null);

	useEffect(() => {
		if (!eventId) return;
		let active = true;
		EventService.getMarketingData(String(eventId))
			.then((res) => {
				if (active) setMarketing(Array.isArray(res?.data) ? res.data.filter((item) => item && typeof item === 'object') : null);
			})
			.catch(() => {
				if (active) setMarketing(null);
			});
		return () => {
			active = false;
		};
	}, [eventId]);

	return marketing;
};
